import { declareVconsoleComponent } from '/vodalys/vvuejs/declareVconsoleComponent.mjs'

declareVconsoleComponent('vconsole17DevicesSelector', () => import('./components/VConsole17DevicesSelector.vue'), 'vconsole17_devices_selector:component')
declareVconsoleComponent('vconsole17DevicesSelectorDisplay', () => import('./components/Vconsole17DevicesSelectorDisplay.vue'))